<template>
  <div class="button-edit py-2 px-4">
    <span class="">{{$t('photoauthedit_note')}}</span>
    <v-text-field class="pt-5" hide-details v-model="form.button" :label="$t('photoauthedit_button')"></v-text-field>
  </div>
</template>

<script>
export default {
  name: 'PhotoAuthEdit',
  props: ['button'],
  data () {
    return {
      form: {
        button: ''
      }
    }
  },
  created () {
    this.form = {
      button: this.button || ''
    }
  }
}
</script>

<style lang="sass">

</style>
